import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Typography,
    Stack,
    Skeleton,
    IconButton,
} from "@mui/material";
import { useGetBrandMyCompetitorsQuery } from "src/context/api/brandPulse/api";
import { useGetBrandLeaderboardQuery } from "src/context/api/leaderboard/api";
import { useCurrentWorkspace } from "src/context/reducers/app-settings";
import Iconify from "src/components/iconify";
import ChartSearchesSpend from "./chartSearchesSpend";
import ChartSearchesVisibility from "./chartSearchesVisibility";

export default function ModalTrackingBrand({
    open,
    onClose,
    domain,
    region,
    page = "My Competitors"
}: {
    open: boolean;
    onClose: () => void;
    domain: string;
    region: string;
    page?: string;
}) {
    const workspace = useCurrentWorkspace();
    const currency = workspace?.currency || 'USD';
    const lang: any = localStorage.getItem('i18nextLng');

    let queryResult;

    if (page === "Leaderboard") {
        queryResult = useGetBrandLeaderboardQuery(
            {
                workspace_id: workspace?.id,
                domain,
                region
            },
            {
                skip: !workspace?.id || !domain || !region,
                refetchOnMountOrArgChange: true,
            }
        );
    } else {
        queryResult = useGetBrandMyCompetitorsQuery(
            {
                workspace_id: workspace?.id,
                domain,
                region
            },
            {
                skip: !workspace?.id || !domain || !region,
                refetchOnMountOrArgChange: true,
            }
        );
    }

    const { data: brand, isLoading, isFetching } = queryResult || {};

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    backgroundColor: "#f5f8fb",
                    borderRadius: 3,
                    zIndex: 99999,
                },
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    height: "60px",
                    px: "24px",
                    py: "20px",
                    alignItems: "center",
                    gap: "2px",
                    alignSelf: "stretch",
                    borderBottom: "1px solid rgba(145, 158, 171, 0.20)",
                }}
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    width="100%"
                    alignItems="center"
                >
                    <Stack direction="row" alignItems="center">
                        <Box
                            sx={{
                                width: 24,
                                height: 24,
                                border: "1px solid rgba(129, 129, 129, 0.2)",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                mr: 1,
                            }}
                        >
                            <img
                                src={`https://www.google.com/s2/favicons?domain=${domain}&sz=32`}
                                alt="favicon"
                                style={{ width: 16, height: 16 }}
                            />
                        </Box>

                        <Typography
                            color="rgba(51, 60, 71, 1)"
                            fontWeight={600}
                            fontSize={17}
                        >
                            {domain}
                        </Typography>
                    </Stack>

                    <IconButton onClick={onClose} size="small">
                        <Iconify icon="eva:close-fill" />
                    </IconButton>
                </Stack>
            </DialogTitle>


            <DialogContent sx={{ px: "24px", mt: "24px", pb: 0 }}>

                {isLoading || isFetching ? (
                    <Skeleton variant="rectangular" width="100%" height={260} />
                ) : (
                    <ChartSearchesVisibility monthlyData={brand?.data || []} currency={currency} lang={lang} />
                )}

                <Box sx={{ mt: "24px", mb: "24px" }}>
                    {isLoading || isFetching ? (
                        <Skeleton variant="rectangular" width="100%" height={260} />
                    ) : (
                        <ChartSearchesSpend monthlyData={brand?.data || []} currency={currency} lang={lang} />
                    )}
                </Box>

            </DialogContent>
        </Dialog >
    );
}